
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EDTypography from '../Typography/EDTypography';

export interface IRapportKontrollEditPositionProps {
  caption?: string;
  value: {
    Width?: number;
    Height?: number;
    Left?: number;
    Top?: number;
    Right?: number;
    Bottom?: number;
    [key: string]: any;
  };
  onChange: (ctrl: any) => void;
}

export const RapportKontrollEditPosition: React.FC<
  IRapportKontrollEditPositionProps
> = props => (
  <Box>
    <EDTypography variant="subtitle2" sx={{ mb: 1 }}>
      {props.caption || 'Placering och storlek'}
    </EDTypography>
    <TextField
      label="Bredd"
      value={props.value.Width ?? ''}
      inputProps={{ maxLength: 4, pattern: '\\d*' }}
      onChange={e =>
        props.onChange({
          ...props.value,
          Width: e.target.value === '' ? undefined : Number(e.target.value),
        })
      }
      fullWidth
      size="small"
      sx={{ mb: 2 }}
    />
    <TextField
      label="Höjd"
      value={props.value.Height ?? ''}
      inputProps={{ maxLength: 4, pattern: '\\d*' }}
      onChange={e =>
        props.onChange({
          ...props.value,
          Height: e.target.value === '' ? undefined : Number(e.target.value),
        })
      }
      fullWidth
      size="small"
      sx={{ mb: 2 }}
    />
    <TextField
      label="Vänster"
      value={props.value.Left ?? ''}
      inputProps={{ maxLength: 4, pattern: '\\d*' }}
      onChange={e =>
        props.onChange({
          ...props.value,
          Left: e.target.value === '' ? undefined : Number(e.target.value),
        })
      }
      fullWidth
      size="small"
      sx={{ mb: 2 }}
    />
    <TextField
      label="Topp"
      value={props.value.Top ?? ''}
      inputProps={{ maxLength: 4, pattern: '\\d*' }}
      onChange={e =>
        props.onChange({
          ...props.value,
          Top: e.target.value === '' ? undefined : Number(e.target.value),
        })
      }
      fullWidth
      size="small"
      sx={{ mb: 2 }}
    />
    <TextField
      label="Höger"
      value={props.value.Right ?? ''}
      inputProps={{ maxLength: 4, pattern: '\\d*' }}
      onChange={e =>
        props.onChange({
          ...props.value,
          Right: e.target.value === '' ? undefined : Number(e.target.value),
        })
      }
      fullWidth
      size="small"
      sx={{ mb: 2 }}
    />
    <TextField
      label="Botten"
      value={props.value.Bottom ?? ''}
      inputProps={{ maxLength: 4, pattern: '\\d*' }}
      onChange={e =>
        props.onChange({
          ...props.value,
          Bottom: e.target.value === '' ? undefined : Number(e.target.value),
        })
      }
      fullWidth
      size="small"
      sx={{ mb: 2 }}
    />
  </Box>
);
